import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';

import {
	setModoTela, initForm
} from './usuarioPerfilActions';

class UsuarioPerfilForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		const listaPermissaoCadastro = [{
			id: 'VISUALIZACAO',
			valor: 'Visualizar'
		}, {
			id: 'VISUALIZACAO,INCLUSAO',
			valor: 'Visualizar e Incluir'
		}, {
			id: 'VISUALIZACAO,ALTERACAO',
			valor: 'Visualizar e Alterar'
		}, {
			id: 'VISUALIZACAO,INCLUSAO,ALTERACAO',
			valor: 'Visualizar, Incluir e Alterar'
		}, {
			id: 'VISUALIZACAO,INCLUSAO,ALTERACAO,EXCLUSAO',
			valor: 'Visualizar, Incluir, Alterar e Excluir'
		}];

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Select
								name='cadastro_perfil'
								options={listaPermissaoCadastro}
								label='Perfil'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_perfil || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_perfil: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_usuario'
								options={listaPermissaoCadastro}
								label='Usuário'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_usuario || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_usuario: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_parceiro'
								options={listaPermissaoCadastro}
								label='Parceiro'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_parceiro || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_parceiro: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_fornecedor'
								options={listaPermissaoCadastro}
								label='Fornecedor'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_fornecedor || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_fornecedor: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_transportadora'
								options={listaPermissaoCadastro}
								label='Transportadora'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_transportadora || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_transportadora: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_tipo_producao'
								options={listaPermissaoCadastro}
								label='Estécie Animal'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_tipo_producao || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_tipo_producao: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_materia_prima'
								options={listaPermissaoCadastro}
								label='Matéria Prima'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_materia_prima || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_materia_prima: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_unidade_medida'
								options={listaPermissaoCadastro}
								label='Unidade de Medida'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_unidade_medida || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_unidade_medida: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_fase'
								options={listaPermissaoCadastro}
								label='Fase'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_fase || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_fase: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_racao'
								options={listaPermissaoCadastro}
								label='Ração'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_racao || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_racao: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_veiculo'
								options={listaPermissaoCadastro}
								label='Veículo'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_veiculo || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_veiculo: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cadastro_motorista'
								options={listaPermissaoCadastro}
								label='Motorista'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cadastro_motorista || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cadastro_motorista: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='solicitacao'
								options={listaPermissaoCadastro}
								label='Solicitação'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.solicitacao || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										solicitacao: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='ordem_producao'
								options={listaPermissaoCadastro}
								label='Ordem de Produção'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.ordem_producao || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										ordem_producao: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='cargas'
								options={listaPermissaoCadastro}
								label='Cargas'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.cargas || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										cargas: data ? data.split(',') : []
									});
								}} />

							<Select
								name='producao_carga'
								options={listaPermissaoCadastro}
								label='Produção da Carga'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.producao_carga || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										producao_carga: data ? data.split(',') : []
									});
								}} />
							
							<Select
								name='analise'
								options={[{ id: 'VISUALIZACAO',	valor: 'Visualizar'	}]}
								label='Análise'
								cols='12 12 4 4'
								placeholder='Selecione'
								readOnly={readOnly}
								value={(this.props.formularioValues.analise || []).join(',')}
								onChange={data => {
									this.props.initForm({
										...this.props.formularioValues,
										analise: data ? data.split(',') : []
									});
								}} />

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }


}

UsuarioPerfilForm = reduxForm({form: 'usuarioPerfilForm', destroyOnUnmount: false})(UsuarioPerfilForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('usuarioPerfilForm')(state),
	registro: state.usuarioPerfil.registro
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioPerfilForm);
